import React from "react";
import Heading from "@insightfulscience/atomic-react/Heading";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import PageTitle from "@insightfulscience/smart-react/PageTitle";
import { useLocale } from "@insightfulscience/smart-react/i18";

const Error404 = () => {
	const [t] = useLocale("app-error");
	return (
		<>
			<PageTitle title={t("404.META_TITLE")} />
			<Heading Tag="h1" level={1} size="xl" center className="mb-6 text-color-1">
				{t("404.TITLE")}
			</Heading>
			<Paragraph size="s" center>
				{t("404.DESCRIPTION")}
			</Paragraph>
		</>
	);
};

export default Error404;
